import { useState } from 'react';

type JsonValidation = {
  jsonValidationError: string;
  validateJSON: (json: string) => void;
  clearJSONValidationError: () => void;
};

function useJSONValidation(): JsonValidation {
  const [jsonValidationError, setJSONError] = useState('');

  const validateJSON = (jsonStr: string) => {
    try {
      JSON.parse(jsonStr);
      setJSONError('');
    } catch (e) {
      if (e instanceof SyntaxError) {
        setJSONError('Content should be a valid JSON');
      } else {
        throw e;
      }
    }
  };

  const clearJSONValidationError = () => {
    setJSONError('');
  };

  return {
    clearJSONValidationError,
    jsonValidationError,
    validateJSON,
  };
}

export default useJSONValidation;
